import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { debug, sortObjectsByAlphabet } from "../../utils";
import * as urlService from "../../view/urlService";


const filters = [
    { id: 1, name: "Scan Type", key: "type", component: TypeFilter },
    { id: 2, name: "Status", key: "status", component: StatusFilter },
    { id: 3, name: "Scheduled", key: "scheduled", component: ScheduledFilter },
]

function ScanSearchSection(
    {
        type = true,
        status = true,
        scheduled = true,
        types
    }) {

    const config = { type, status, scheduled };
    const history = useHistory();
    const [selectedFilter, selectFilter] = useState(filters[0]);
    //const [filterValue, setFilterValue] = useState(null);
    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {

        const pageFilters = urlService.getFilters(true);

        if (pageFilters.type) {
            selectFilter(filters[0])
            setFilterValue(pageFilters.type)
        }

        if (pageFilters.status) {
            selectFilter(filters[1])
            setFilterValue(pageFilters.status)
        }

        if (pageFilters.scheduled) {
            selectFilter(filters[2])
            setFilterValue(pageFilters.scheduled)
        }        

    }, [])

    const onFilterChange = (value) => {
        setFilterValue('')
        // history.replace({
        //     pathname: history.pathname,
        //     search: urlService.removeFilter(selectedFilter.key)
        // })
        const filter = filters.find(filter => filter.id === Number(value))
        selectFilter(filter);
    }

    const onSearchChange = (value) => {

        if (value) {
            history.replace({
                pathname: history.pathname,
                search: urlService.updateVulScanSearchFilters(selectedFilter.key, value)
            })

        } else {
            history.replace({
                pathname: history.pathname,
                search: urlService.removeFilter(selectedFilter.key)
            })
        }

        setFilterValue(value);
    }

    const renderFilter = (filter) => {
        const Component = filter.component;
        return <Component onSearchChange={onSearchChange} filterValue={filterValue} types={types}/>
    }

    return (
        <div className="network-scan-search-v2 network-scan-search-v2--filters">
            <span className="network-scan-search-label-v2">Filter/Search</span>
            <div>
                <select className="network-scan-search-select-v2"
                    value={selectedFilter.id}
                    onChange={event => onFilterChange(event.target.value)}>
                    {
                        filters.map((filter, index) => {
                            return config[filter.key] && <option key={index} value={filter.id}>{filter.name}</option>
                        })
                    }
                </select>
            </div>
            {
                renderFilter(selectedFilter)
            }
            {/* {device && <DeviceDropdown/>} */}
        </div>
    )
}

function TypeFilter({ onSearchChange, filterValue, types }) {
    //const types = ScanSearchSection.scanTypes;
    
    
    const typesCopy = sortObjectsByAlphabet(types, 'type');
    
    return (
        <div>
            <select className="network-scan-search-select-v2" id="scanTypeFilter"
                    value={filterValue}
                    onChange={event => onSearchChange(event.target.value)}>
                    <option value={''}>Select</option>
                    {
                        typesCopy &&
                        typesCopy.map((type, index) => <option key={index} value={type.type}>{type.type}</option>)
                    }
            </select>
        </div>
    )
}

function StatusFilter({ onSearchChange, filterValue }) {
    return (
        <div>
            <select className="network-scan-search-select-v2"
                onChange={event => onSearchChange(event.target.value)}
                value={filterValue}>
                <option value={''}>Select</option> {/*selected={true} */}
                <option value={'Completed'}>Completed</option>
                <option value={'Aborted'}>Aborted</option>
            </select>
            {/* <button className="btn">
                    <span className="icon-search"/>
                </button> */}
        </div>
    )
}

function ScheduledFilter({ onSearchChange, filterValue }) {
    return (
        <div>
            <select className="network-scan-search-select-v2"
                onChange={event => onSearchChange(event.target.value)}
                value={filterValue}>
                <option value={''}>Select</option> {/*selected={true} */}
                <option value={'Disabled'}>Disabled</option>
                <option value={'Scheduled'}>Scheduled</option>
                <option value={'No Schedule'}>No Scheduled</option>
            </select>
            {/* <button className="btn">
                    <span className="icon-search"/>
                </button> */}
        </div>
    )
}

function mapStateToProps(state) {
    debug("ScanSearchSection mapStateToProps", state);
    const vulscanPage = state.vulscanPage;
    return {
        types: vulscanPage.scanTypes || []
    };
}

export default connect(mapStateToProps)(ScanSearchSection);
